
import React, { useRef } from 'react';
import ReactOwlCarousel from 'react-owl-carousel';
import { Link } from 'react-router-dom';
import { LuMoveRight, LuMoveLeft } from "react-icons/lu";
import { ImageUrl } from '../../../../../../Helpers/request';
import { Col, Container, Row } from 'react-bootstrap';
import Slider from 'react-slick';
import round from '../../assets/images/diamond-shape-img/round-diamond.png'
import princess from '../../assets/images/diamond-shape-img/princess-diamond.png'
import cushion from '../../assets/images/diamond-shape-img/cushion-diamond.png'
import emerald from '../../assets/images/diamond-shape-img/emerald-diamond.png'
import oval from '../../assets/images/diamond-shape-img/oval-diamond.png'
import radiant from '../../assets/images/diamond-shape-img/radiant-diamond.png'
import asscher from '../../assets/images/diamond-shape-img/asscher-diamond.png'
import marquise from '../../assets/images/diamond-shape-img/marquise-diamond.png'
import heart from '../../assets/images/diamond-shape-img/heart-diamond.png'
import pear from '../../assets/images/diamond-shape-img/pear-diamond.png'
import left from '../../../newyork/assets/images/left-arrow.png'
import right from '../../../newyork/assets/images/right-arrow.png'

const diamondShapes = [
    { id: 1, name: "Round", img: round, link: "diamonds/shape=Round", desc: 'Cut with the optimum light refraction and sparkle.' },
    { id: 2, name: "Princess", img:princess, link: "diamonds/shape=Princess", desc: "A contemporary cut, with optimal fire and brilliance." },
    { id: 3, name: "Cushion", img: cushion, link: "diamonds/shape=Cushion", desc: 'With soft corners, a beautiful alternative to a round or princess cut.' },
    { id: 4, name: "Emerald", img: emerald, link: "diamonds/shape=Emerald", desc: "This stylish cut creates rectangular facets with great stone's clarity." },
    { id: 5, name: "Oval", img: oval, link: "diamonds/shape=Oval", desc: "Optimises carat, giving the illusion of a larger stone." },
    { id: 6, name: "Radiant", img:radiant, link: "diamonds/shape=Radiant", desc: "The most brilliant of the rectangular cut diamonds." },
    { id: 7, name: "Asscher", img: asscher, link: "diamonds/shape=Asscher", desc: 'This unique shape is a square emerald, with linear facets.' },
    { id: 8, name: "Marquise", img: marquise, link: "diamonds/shape=Marquise", desc: "Elongate the finger of the wearer with a look of great grandeur." },
    { id: 9, name: "Heart", img: heart, link: "diamonds/shape=Heart", desc: "A rare cut that is a true testament of your relationship." },
    { id: 10, name: "Pear", img: pear, link: "diamonds/shape=Pear", desc: "Combining the brilliance and design of the Round and Marquise cuts." },
];

export const ShopDiamondShape = () => {
    const carouselRef = useRef(null);
    const settings = {
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 1800,
  speed: 600,
  slidesToShow: 10,          // <-- 10 FULL SLIDES
  slidesToScroll: 1,
  arrows: false,   // <-- adjust side visibility
 prevArrow: <img src={left} className="img-fluid"  alt="left arrow"/>,
    nextArrow: <img src={right} className="img-fluid" alt="right arrow"/>,

  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 10,
        arrows:false,
      },
    },
    {
      breakpoint: 1400,
      settings: { 
        slidesToShow: 10,
         arrows: false,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 10,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 5,
        centerMode: true,
        centerPadding: "40px",
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        centerMode: true,
        centerPadding: "30px",
        arrows:true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        centerMode: true,
        centerPadding: "20px",
          arrows:true,
      },  
    },
  ],
};


    return (
        <>
            <section className='shop_diamond_shape'>
                <Container className='container-whitebox bg_color_primary' style={{borderRadius:"20px"}}>
                    <Row>
                        <Col sm={12} md={12}>
                    <div className='title-box text-center text-white mb-4'>
                        <h2 style={{fontSize:"30px", lineHeight:"35px"}}>Shop Diamonds By Shape</h2>
                        <p className='text-white'>Find Your Perfect Shape, Find Your Sparkle</p>
                    </div>
                        </Col>
                    </Row>
                     <Col sm={12} md={12}>
             <Slider {...settings} className='white_shape_slider'>
  {diamondShapes.map((shape) => (
    <div className="item text-center" key={shape.id}>
      <Link to={shape.link}>
        <img
          src={shape.img}
          alt={shape.name}
        />
        <div className="content position-relative">
          <Link to={shape.link}>
            {shape.name}
          </Link>
        </div>
      </Link>
    </div>
  ))}
</Slider>
                     </Col>

                </Container>
            </section>
        </>
    );
};
